import { effect } from '../../../reactivity/effects.js';
import { listen_to_event_and_reset_event } from './shared.js';
import { untrack } from '../../../runtime.js';
import { is } from '../../../proxy.js';
import { is_array } from '../../../../shared/utils.js';
import * as w from '../../../warnings.js';

/**
 *
 *
 *
 *
 *
 */
export function select_option(select, value, mounting) {
	if (select.multiple) {
		/*                                                      */
		if (value == undefined) {
			return;
		}

		/*                                                 */
		if (!is_array(value)) {
			return w.select_multiple_invalid_value();
		}

		/*                              */
		return select_options(select, value);
	}

	for (var option of select.options) {
		var option_value = get_option_value(option);
		if (is(option_value, value)) {
			option.selected = true;
			return;
		}
	}

	if (!mounting || value !== undefined) {
		select.selectedIndex = -1; /*                           */
	}
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function init_select(select, get_value) {
	let mounting = true;
	effect(() => {
		if (get_value) {
			select_option(select, untrack(get_value), mounting);
		}
		mounting = false;

		var observer = new MutationObserver(() => {
			/*         */
			var value = select.__value;
			select_option(select, value);
			/*                                                     */
			/*                                                      */
		});

		observer.observe(select, {
			/*                               */
			childList: true,
			subtree: true, /*                    */
			/*                                               */
			/*                                             */
			/*                                                      */
			attributes: true,
			attributeFilter: ['value']
		});

		return () => {
			observer.disconnect();
		};
	});
}

/**
 *
 *
 *
 *
 */
export function bind_select_value(select, get, set = get) {
	var mounting = true;

	listen_to_event_and_reset_event(select, 'change', (is_reset) => {
		var query = is_reset ? '[selected]' : ':checked';
		/*                  */
		var value;

		if (select.multiple) {
			value = [].map.call(select.querySelectorAll(query), get_option_value);
		} else {
			/*                                   */
			var selected_option =
				select.querySelector(query) ??
				/*                                                                   */
				select.querySelector('option:not([disabled])');
			value = selected_option && get_option_value(selected_option);
		}

		set(value);
	});

	/*                                                                                                                        */
	effect(() => {
		var value = get();
		select_option(select, value, mounting);

		/*                                                      */
		if (mounting && value === undefined) {
			/*                                   */
			var selected_option = select.querySelector(':checked');
			if (selected_option !== null) {
				value = get_option_value(selected_option);
				set(value);
			}
		}

		/*         */
		select.__value = value;
		mounting = false;
	});

	/*                                                                 */
	init_select(select);
}

/**
 *
 *
 */
function select_options(select, value) {
	for (var option of select.options) {
		option.selected = value.includes(get_option_value(option));
	}
}

/*                                    */
function get_option_value(option) {
	/*                                                        */
	if ('__value' in option) {
		return option.__value;
	} else {
		return option.value;
	}
}
